export function coerceString(title: string | null) {
  return title || "";
}
